import DashboardBusinessesList from "./DashboardBusinessesList";

export default DashboardBusinessesList;
